import $ from 'jquery';

$(window).on("scroll", (function () {
  if ($(document).scrollTop() > 0) {
    if (!$(".header-wrapper").hasClass("to-white")) {
      $(".header-wrapper").addClass("to-white")
    }
  }
  else {
    if ($(".header-wrapper").hasClass("to-white")) {
      $(".header-wrapper").removeClass("to-white")
    }
  }
}))